module.exports = __webpack_public_path__ + "static/media/icon-lp-personalized-care.b92f0854.svg";